import React, { useState, useEffect, useRef } from 'react';
import Tree from 'rc-tree';
import 'rc-tree/assets/index.css';
import fnc from '../mymod/commFunction';
import ContextMenu from './ContextMenu'; // 컨텍스트 메뉴 컴포넌트
import './SaveTest_tv.scss'; // 스타일 추가

const LOCAL_STORAGE_KEY = 'treeViewState';

const SaveTest_tv = ({ setSelectedNodeId, testCnt }) => {
    const [treeData, setTreeData] = useState([]);
    const [selectedNode, setSelectedNode] = useState(null); // 현재 우클릭한 노드
    const [contextMenuPosition, setContextMenuPosition] = useState(null); // 컨텍스트 메뉴 위치
    const containerRef = useRef(null); // 컨테이너 참조

    const [expandedKeys, setExpandedKeys] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [selectedNodeText, setSelectedNodeText] = useState('');

    const acaCode = fnc.getCookie('acaCode');
    const stCode = fnc.getCookie('stCode');

    useEffect(() => {
        // 로컬 스토리지에서 저장된 상태 로드
        const savedState = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
        if (savedState) {
            setExpandedKeys(savedState.expandedKeys || []);
            setSelectedKeys(savedState.selectedKeys || []);
            setSelectedNodeId(savedState.selectedKeys?.[0] || null);
            setSelectedNodeText(savedState.selectedNodeText);
        }

        loadTreeData();
    }, []);

    useEffect(() => {
        // 선택 및 펼친 상태를 로컬 스토리지에 저장
        localStorage.setItem(
            LOCAL_STORAGE_KEY,
            JSON.stringify({
                expandedKeys,
                selectedKeys,
                selectedNodeText,
            })
        );
    }, [expandedKeys, selectedKeys]);

    const loadTreeData = () => {
        fnc.sendAxios('/saveTestRoutes/treeview/select/node', {stCode}, (res) => {

            if (res) {
                if (res.length === 0) {
                    addNode_initial('ROOT', 'ROOT');
                }
                const formattedData = formatTreeData(res);
                setTreeData(formattedData);
            } else {
                console.error('Failed to fetch tree data.');
            }
        });
    };

    const formatTreeData = (data) => {
        const nodeMap = {};
        const tree = [];

        data.forEach((node) => {
            nodeMap[node.NodeID] = {
                key: String(node.NodeID),
                title: node.Name,
                parentID: node.ParentID,
                children: [],
            };
        });

        data.forEach((node) => {
            if (node.ParentID === 'ROOT') {
                tree.push(nodeMap[node.NodeID]);
            } else if (nodeMap[node.ParentID]) {
                nodeMap[node.ParentID].children.push(nodeMap[node.NodeID]);
            }
        });

        return tree;
    };

    const addNode = (parentID, nodeName) => {
        const name = prompt('새 노드 이름을 입력하세요!', nodeName);
        if (!name) return;
        const nodeID = fnc.fncSirialNum('N');
        fnc.sendAxios('/saveTestRoutes/treeview/insert/node', { NodeID: nodeID, ParentID: parentID, Name: name, stCode }, (res) => {
            if (res) {
                loadTreeData();
            } else {
                console.error('Failed to add node.');
            }
        });
    };

    const addNode_initial = (parentID, name) => {
        if (!name) return;
        const nodeID = fnc.fncSirialNum('S');
        fnc.sendAxios('/saveTestRoutes/treeview/insert/node', { NodeID: nodeID, ParentID: parentID, Name: name, stCode }, (res) => {
            if (res) {
                loadTreeData();
            } else {
                console.error('Failed to add node.');
            }
        });
    };

    const editNode = (nodeID, nodeName) => {
        const newName = prompt('새 노드 이름을 입력하세요!', nodeName);
        if (!newName) return;

        fnc.sendAxios('/saveTestRoutes/treeview/update/node', { NodeID: nodeID, Name: newName }, (res) => {
            if (res) {
                loadTreeData();
            } else {
                console.error('Failed to update node.');
            }
        });
    };

    const deleteNode = (nodeID, nodeName) => {

            if (testCnt > 0) {
                alert('시험지를 먼저 모두 삭제하세요!');
                return;
            }
      
            fncCntChildNode (nodeID, nodeName, (childCount) => {
                    
                if (childCount !== 0) {
                    alert('하위 노드 부터 삭제하세요!');
                    return;
                } else {

                    if (!window.confirm(`정말로 ${nodeName}을 삭제하시겠습니까?`)) return;
                    fnc.sendAxios('/saveTestRoutes/treeview/delete/node', { NodeID: nodeID }, (res) => {
                        if (res) {
                            loadTreeData();
                        } else {
                            console.error('Failed to delete node.');
                        }
                    });   
                }

        });


        // fnc.sendAxios('/saveTestRoutes/treeview/delete/node', { NodeID: nodeID }, (res) => {
        //     if (res) {
        //         loadTreeData();
        //     } else {
        //         console.error('Failed to delete node.');
        //     }
        // });
    };

     const fncCntChildNode = (nodeID, nodeName, callback) => {
        // if (!window.confirm(`정말로 ${nodeName}을 삭제하시겠습니까11?`)) return;

        fnc.sendAxios('/saveTestRoutes/treeview/select/cntChildNode', { NodeID: nodeID }, (res) => {
            if (res) {
                const childCount = res[0].childCount;

                callback(childCount);
                // alert(childCount);
                // console.log(res, '/saveTestRoutes/ res');
            } else {
                callback(-1);
                alert('/saveTestRoutes/isChildNode');

            }
        });
    };

    const handleRightClick = (info) => {
        const bounds = containerRef.current?.getBoundingClientRect() || { left: 0, top: 0, width: window.innerWidth, height: window.innerHeight };

        const menuWidth = 150; // 컨텍스트 메뉴 너비
        const menuHeight = 100; // 컨텍스트 메뉴 높이

        let x = info.event.clientX - bounds.left;
        let y = info.event.clientY - bounds.top;

        // 경계를 넘어가지 않도록 위치 보정
        if (x + menuWidth > bounds.width) {
            x = bounds.width - menuWidth;
        }
        if (y + menuHeight > bounds.height) {
            y = bounds.height - menuHeight;
        }

        setSelectedNode(info.node);
        setContextMenuPosition({ x, y });
        info.event.preventDefault();
    };

    const closeContextMenu = () => {
        setContextMenuPosition(null); // 컨텍스트 메뉴 닫기
    };

    const handleDrop = (info) => {
        const dragNodeID = info.dragNode.key; // 드래그된 노드 ID
        const dropParentID = info.node.key; // 드롭된 부모 노드 ID

        if (dragNodeID === dropParentID) return; // 자기 자신에게 드롭 방지

        fnc.sendAxios('/saveTestRoutes/treeview/move/node', { NodeID: dragNodeID, ParentID: dropParentID }, (res) => {
            if (res) {
                loadTreeData();
            } else {
                console.error('Failed to move node.');
            }
        });
    };

    const renderTree = (data) =>
        data.map((item) => ({
            ...item,
            title: <span>{item.title}</span>,
            children: item.children ? renderTree(item.children) : [],
        }));

    const onExpand = (expandedKeys) => {
        setExpandedKeys(expandedKeys);
    };

    const onSelect = (selectedKeys, selectedItem) => {//선택
        // 그룹일 경우 펼침/닫힘 토글
      
        if (selectedItem.node.children) {
            
            setExpandedKeys((keys) => {
                if (keys.includes(selectedItem.node.key)) {
                    return keys.filter((key) => key !== selectedItem.node.key); // 이미 펼쳐진 경우 닫기     
                } else {
      
                    return [...keys, selectedItem.node.key]; // 펼치기
                    
                }
            });
        }


        setSelectedKeys(selectedKeys); // active 상태 유지
        setSelectedNodeId(selectedKeys[0]); // 다중 선택이 아니므로 배열에 하나만 존재
 

        if (selectedKeys[0]) {
            setSelectedNodeText(selectedItem.node.title.props.children);
        }else {
            setSelectedNodeText('');
        }
        
    };

    return (
        <div ref={containerRef} className="SaveTest_tv" onClick={closeContextMenu}>
            <section className="section-title">
                {/* <div className='title'>{`${selectedKeys} - ${selectedNodeText}`}</div> */}
                <div className='title'>{`${selectedNodeText}`}</div>
            </section>

            <section className="section-treeview">
                <Tree
                    treeData={renderTree(treeData)}
                    onRightClick={handleRightClick} // 우클릭 이벤트
                    draggable={true} // 드래그 앤 드롭 활성화
                    onDrop={handleDrop} // 드롭 이벤트 핸들러
                    onExpand={onExpand}
                    expandedKeys={expandedKeys}
                    selectedKeys={selectedKeys}
                    onSelect={onSelect}
                />
            </section>

            {contextMenuPosition && (
                <ContextMenu
                    position={contextMenuPosition}
                    onAdd={() => {
                        addNode(selectedNode?.key, selectedNode?.title?.props?.children);
                        closeContextMenu();
                    }}
                    onEdit={() => {
                        editNode(selectedNode?.key, selectedNode?.title?.props?.children);
                        closeContextMenu();
                    }}
                    onDelete={() => {
                        deleteNode(selectedNode?.key, selectedNode?.title?.props?.children);
                        closeContextMenu();
                    }}
                    onClose={() => {
                        closeContextMenu();
                    }}
                />
            )}
        </div>
    );
};

export default SaveTest_tv;
